import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Tooltip as MuiTooltip, Grow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import colors from '../../foundations/colors.module.scss';
import typography from '../../foundations/typography.module.scss';
import { useDevice } from '../../providers/Device';
import { useIsInBottomSheet } from '../../providers/IsInBottomSheetProvider';
import { PopoverArrowIcon } from '../PopoverArrowIcon';
const NoTransition = (props)=>/*#__PURE__*/ _jsx(Grow, _object_spread_props(_object_spread({}, props), {
        timeout: 0
    }));
const useStyles = makeStyles({
    tooltip: {
        fontFamily: typography.fontFamilyLight,
        fontSize: typography.fontSizeP1,
        color: colors.dark50,
        background: colors.dark900,
        padding: 12,
        borderRadius: 8,
        maxWidth: 'min(460px, 75vw)'
    },
    tooltipPlacementTop: {
        marginBottom: 12,
        '& $customArrow': {
            bottom: 4
        }
    },
    tooltipPlacementBottom: {
        marginTop: 12,
        '& $customArrow': {
            top: 4
        },
        '& $arrowInner': {
            transform: 'rotate(180deg)'
        }
    },
    tooltipPlacementLeft: {
        marginRight: 12,
        '& $customArrow': {
            right: -6
        },
        '& $arrowInner': {
            transform: 'rotate(270deg)'
        }
    },
    tooltipPlacementRight: {
        marginLeft: 12,
        '& $customArrow': {
            left: -6
        },
        '& $arrowInner': {
            transform: 'rotate(90deg)'
        }
    },
    customArrow: {
        position: 'absolute',
        width: 29,
        height: 9,
        color: colors.dark900
    },
    centeredArrow: {
        '& $customArrow': {
            left: '50% !important',
            transform: 'translateX(-50%)'
        }
    },
    arrowInner: {
        position: 'absolute'
    }
});
export function Tooltip(props) {
    const { title, disableArrow, centerArrow, testId, enableOnMobile, placement = 'top' } = props, rest = _object_without_properties(props, [
        "title",
        "disableArrow",
        "centerArrow",
        "testId",
        "enableOnMobile",
        "placement"
    ]);
    const { isMobileDevice } = useDevice();
    const isInBottomSheet = useIsInBottomSheet();
    const [arrowRef, setArrowRef] = useState(null);
    const _useStyles = useStyles(), { customArrow, arrowInner, centeredArrow } = _useStyles, restStyles = _object_without_properties(_useStyles, [
        "customArrow",
        "arrowInner",
        "centeredArrow"
    ]);
    if ((isMobileDevice || isInBottomSheet) && !enableOnMobile) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: props.children
        });
    }
    return /*#__PURE__*/ _jsx(MuiTooltip, _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, rest), {
        placement: placement
    }), testId != null ? {
        'data-testid': testId
    } : {}), {
        arrow: false,
        enterTouchDelay: 0,
        leaveTouchDelay: 3000,
        title: title && /*#__PURE__*/ _jsx("span", {
            "data-testid": testId,
            children: !disableArrow ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        ref: setArrowRef,
                        className: customArrow,
                        children: /*#__PURE__*/ _jsx(PopoverArrowIcon, {
                            className: arrowInner
                        })
                    }),
                    title
                ]
            }) : title
        }),
        // Necessary because our custom arrow appears with a delay when there's a transition.
        TransitionComponent: NoTransition,
        PopperProps: {
            popperOptions: {
                modifiers: {
                    arrow: disableArrow ? undefined : {
                        enabled: Boolean(arrowRef),
                        element: arrowRef
                    }
                }
            }
        },
        classes: _object_spread({}, restStyles, centerArrow && {
            tooltip: "".concat(restStyles.tooltip, " ").concat(centeredArrow)
        })
    }));
}
